@if (isSyncing()) {
  <ke-ui-application-loader />
}
<ke-ui-skip-to-main></ke-ui-skip-to-main>
<router-outlet></router-outlet>
